// The campaign cost answer as the builder sidebar uses it: the estimate
// (null with a reason when its read was refused — unknown, never 0), the
// actual cost, and the coverage of the reads (uncovered = incomplete; Codex
// confirmation review 6).
export const toCampaignCost = (result) => ({
  estimated: result?.estimatedCost ?? null,
  estimatedUnavailable: result?.estimatedCostUnavailable ?? null,
  actual: result?.realCost ?? null,
  coverage: result?.coverage ?? null,
});
